import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
const InfoContainer = styled.p(
  ({ theme }) => `
  font-size: ${theme.fonts.size.small};
  color: ${theme.colors.text.secondary};
`
);
const SaveContextInfo = () => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(InfoContainer, null, t("save_context_info.text"));
};
export default SaveContextInfo;
